var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.764 1.99a.6.6 0 0 1 .6.6v1.282h2.223a2.483 2.483 0 0 1 2.483 2.481v13.176a2.483 2.483 0 0 1-2.483 2.482H5.412A2.48 2.48 0 0 1 2.93 19.53V6.353a2.48 2.48 0 0 1 2.482-2.481h2.223V2.589a.6.6 0 1 1 1.2 0v1.283h6.33V2.589a.6.6 0 0 1 .6-.6M4.13 10.718v8.81c0 .709.575 1.283 1.283 1.283h13.175c.708 0 1.283-.574 1.283-1.282v-8.81zm1.283-5.647c-.708 0-1.282.574-1.283 1.282v3.166h15.74V6.353c0-.708-.574-1.282-1.282-1.282h-2.223v1.283a.6.6 0 0 1-1.2 0V5.071h-6.33v1.283a.6.6 0 1 1-1.199 0V5.071z"
  })));
};
export default SvgCalendar;